<template>
  <div
    class="m-dropdown-content m-dropdown-content-right"
    :id="`MoleculeEditionBillingAcademyUsersDropDownActors-${index}`"
  >
    <section class="m-dropdown-section">
      <ul class="m-dropdown-list">
        <li
          v-for="(actor, index) in actores"
          :key="index"
        >
          <a
            class="font-size-small no-action"
            href="#"
            @click.prevent=""
          >
            <span class="m-dropdown-item-icon">
              <i :class="actor.habilitado ? 'far fa-check-circle text-color-success' : 'fas fa-ban text-color-danger'"></i>
            </span>
            <span class="m-dropdown-item-text">
              {{ actoresTipo.find(actorTipo => actorTipo.id === actor.tipo).name }}
            </span>
          </a>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingAcademyUsersDropDownActors',

  props: {
    actores: Array,
    index: Number
  },

  data () {
    return {
      actoresTipo: [...this.$filters.parameters['actors']]
    }
  },

  created () {
    this.actoresTipo.push({ id: 5, name: 'SuperAdministrador' })
  }
}
</script>
